const textFieldFormService = {
  accountable: 'Accountable',
  document: 'Document (RG or CPF)',
  description: 'Comments'
};

export default textFieldFormService;
